import React, { useState, useContext } from 'react';
import { useHistory } from "react-router-dom";
import toastError from "../../errors/toastError";
import api from "../../services/api";

import Avatar from "@material-ui/core/Avatar";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";

import { AuthContext } from "../../context/Auth/AuthContext";
import { formatPhoneNumber } from "../../utils/formatPhoneNumber";

import { Button, Divider, } from "@material-ui/core";

const VcardPreview = ({ contact, numbers }) => {
    const history = useHistory();
    const { user } = useContext(AuthContext);
    const [loading, setLoading] = useState(false);

    const number = numbers ? String(numbers).replace(/\D/g, "") : "";
    const name = contact || number || "Contacto";

    // The contact is only looked up / created when the agent decides to chat
    const handleNewChat = async () => {
        if (!number) return;
        setLoading(true);
        try {
            const { data: selectedContact } = await api.post("/contact", {
                name,
                number,
                email: ""
            });
            const { data: ticket } = await api.post("/tickets", {
                contactId: selectedContact.id,
                userId: user.id,
                status: "open",
            });
            history.push(`/tickets/${ticket.id}`);
        } catch (err) {
            toastError(err);
        }
        setLoading(false);
    }

    return (
        <>
            <div style={{
                minWidth: "250px",
            }}>
                <Grid container spacing={1}>
                    <Grid item xs={2}>
                        <Avatar>{name.trim().charAt(0).toUpperCase()}</Avatar>
                    </Grid>
                    <Grid item xs={10}>
                        <Typography style={{ marginLeft: "10px" }} variant="subtitle1" color="primary">
                            {name}
                        </Typography>
                        {number && (
                            <Typography style={{ marginLeft: "10px" }} variant="body2" color="textSecondary" gutterBottom>
                                {formatPhoneNumber(number)}
                            </Typography>
                        )}
                    </Grid>
                    <Grid item xs={12}>
                        <Divider />
                        <Button
                            fullWidth
                            color="primary"
                            onClick={handleNewChat}
                            disabled={!number || loading}
                        >Conversar</Button>
                    </Grid>
                </Grid>
            </div>
        </>
    );

};

export default VcardPreview;
